import Vue from 'vue';
import Router from 'vue-router';

//一级路由
import Home from './views/Home'
import Case from './views/Case'
import About from './views/About'
// import ArticleDetail from './views/ArticleDetail.vue'

//二级路由
// import Note from './views/search/Note.vue'
// import Users from './views/search/Users.vue'
// import Collection from './views/search/Collection.vue'
// import NoteBook from './views/search/NoteBook.vue'


Vue.use(Router);

const routes = [
    {path: '/', redirect: '/home' },
    {path:'/home', name: 'home', component: Home },
    {path: '/case', name: 'case', component: Case},
    {path: '/about', name: 'about', component: About},
    {
        path: '/download',
        name: 'download',
        component: () => import('./views/Download'),
    }
]

export default new Router({
    routes,
    mode:'history',
});
